import { useQuery, useMutation } from "urql";

const PASSWORDS = `query PASSWORDS(
    $companyId: String!
    $pagination: PaginationInput!
    $search: String
  ) {
    paginatedPasswordsByCompanyId(
      companyId: $companyId
      pagination: $pagination
      search: $search
    ) {
      totalDocs
      docs {
        id
        name
        templateId
        allowedRoles 
        createdAt
        description
        isActive
      }
    }
  }`;

export const GetPasswords = (companyId, pagination, search) => {
  const [result, reexecuteQuery] = useQuery({
    query: PASSWORDS,
    variables: { companyId, pagination, search },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const PASSWORD_BY_COMPANY = `query PASSWORDS_BY_COMPANY(
  $companyId: String!
) {
  allPasswordsByCompanyId(
    companyId: $companyId
  ){
    id
    name
    templateId
    allowedRoles 
    createdAt
    description
    isActive
    isUpdating
    botlogSummary{
      id
      botend
      end
      status
      mssg
    }
  }
}`;

export const GetPasswordsByCompany = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: PASSWORD_BY_COMPANY,
    variables: {companyId}
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CREATE_PASSWORD = `mutation CREATE_PASSWORD(
  $name: String!
  $companyId: String!
  $templateId: TemplateId!
  $allowedRoles: [String!]
  $content: JSONObject!
  $description: String
  $reconcile: Boolean
  $reconcileUntil: String
) {
  createPassword(
    input: {
      name: $name
      companyId: $companyId
      templateId: $templateId
      allowedRoles: $allowedRoles
      description: $description
      reconcile: $reconcile
      reconcileUntil: $reconcileUntil
      content: $content
    }
  ) {
    id
  }
}
`;
export const CreatePassword = () => {
  const [exclude, createPassword] = useMutation(CREATE_PASSWORD);
  return createPassword;
};

const UPDATE_PASSWORD = `mutation UPDATE_PASSWORD(
  $id: String!
  $name: String!
  $companyId: String!
  $templateId: TemplateId!
  $allowedRoles: [String!]
  $content: String
  $description: String
  $reconcile: Boolean
  $isActive: Boolean
  $isUpdating: Boolean
) {
  updatePassword(
    id: $id
    input: {
      name: $name
      companyId: $companyId
      templateId: $templateId
      allowedRoles: $allowedRoles
      content: $content
      description: $description
      reconcile: $reconcile
      isActive: $isActive
      isUpdating: $isUpdating
    }
  ) {
    id
  }
}`;

export const UpdatePassword = () => {
  const [exclude, updatePassword] = useMutation(UPDATE_PASSWORD);
  return updatePassword;
};

const GET_PASSWORD = `query GET_PASSWORD($id: String!) {
  Password(id: $id) {
    id
    templateId
    content
    reconcile
    companyId {
      id
    }
    name
    description
    allowedRoles
    createdAt
  }
}
`;

export const GetSelectedPassword = (id) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_PASSWORD,
    variables: { id },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const DELETE_PASSWORD = `mutation DELETE_PASSWORD($id: String!) {
  deletePassword(id: $id) {
    id
  }
}
`;
export const DeletePassword = () => {
  const [exclude, deletePassword] = useMutation(DELETE_PASSWORD);
  return deletePassword;
};
